export class AreaCalibrationsModel {
    public commesse: any[] = []; 
    public site: string;
    public profile: any;
    public type_user: any;
    public notes: string;
    public sub_system: any; 

    public phone:string | null;
    public company:string | null;
    public stamp_code:string | null;
    public function:string | null;
}

export class OrderModel {
  id: string;
  project_name: string;
  active: boolean;
  cdc_type: string;
  project_description: string;
}





